export default __webpack_public_path__ + "static/media/content3840.3f0eb30b.png";